"use client";

import { createContext, useContext, type ReactNode } from "react";

interface AudienceAnalyticsContextValue {
  username?: string;
  creatorId?: string;
}

const AudienceAnalyticsContext = createContext<AudienceAnalyticsContextValue>({
  username: undefined,
  creatorId: undefined,
});

interface AudienceAnalyticsProviderProps {
  username?: string;
  creatorId?: string;
  children: ReactNode;
}

/**
 * Provider for audience analytics context
 * Wraps pages where audience members view creator profiles
 * Automatically injects username into all audience analytics events
 */
export function AudienceAnalyticsProvider({
  username,
  creatorId,
  children,
}: AudienceAnalyticsProviderProps) {
  return (
    <AudienceAnalyticsContext.Provider value={{ username, creatorId }}>
      {children}
    </AudienceAnalyticsContext.Provider>
  );
}

/**
 * Hook to access audience analytics context
 * Returns the current creator's username for analytics tracking
 */
export function useAudienceAnalyticsContext() {
  return useContext(AudienceAnalyticsContext);
}
